module.exports = __webpack_public_path__ + "img/jobimg.fda5ec33.png";